var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isSubgroupHidden,
      expression: "isSubgroupHidden"
    }],
    attrs: {
      "elementType": "div",
      "customClass": _vm.$props.customsClasses
    }
  }, [_c('CustomContainer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.hasNoSubgroups,
      expression: "!hasNoSubgroups"
    }],
    attrs: {
      "elementType": "div",
      "customClass": ['subgroup-title', _vm.subgroup.name + '-group']
    }
  }, [_c('CustomText', {
    staticClass: "price",
    attrs: {
      "elementType": "span",
      "text": _vm.getUpchargeDisplay(_vm.$props.groupName, _vm.subgroup.name)
    }
  }), _c('CustomText', {
    staticClass: "title",
    attrs: {
      "elementType": "span",
      "text": _vm.subgroup.display_name
    }
  }, [_c('template', {
    slot: "child"
  }, [_c('CustomContainer', {
    staticClass: "icon-help",
    attrs: {
      "elementType": "span"
    }
  })], 1)], 2), _c('CustomText', {
    staticClass: "subtitle",
    attrs: {
      "elementType": "span"
    }
  })], 1), _vm._l(_vm.subgroup.swatches, function (swatch) {
    return _c('Swatch', {
      key: "".concat(_vm.subgroup.name, "-").concat(swatch.id).concat(swatch.color ? '-' + swatch.color : ''),
      attrs: {
        "swatchData": swatch,
        "disabled": !!_vm.ugcBlockedPalette || Number(swatch.id) == 10900,
        "customsClasses": "tooltip swatch"
      }
    });
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }